import PropTypes from 'prop-types'
import { useState } from 'react'
import { Element } from '../html/element'
import { Cell } from './Cell'

export const Row = ({
  getDataFromRedux,
  rowId,
  rowIndex,
  schema,
  isStickyFirstCol,
  onRowClick,
  onRightClick,
  selectedRowId,
  isSelectNotIn,
}) => {
  const isSelected =
    typeof selectedRowId === 'object'
      ? !isSelectNotIn
        ? selectedRowId[rowId]
        : !selectedRowId[rowId]
      : selectedRowId === rowId

  const [isHovered, setIsHovered] = useState(false)

  const onMouseEnter = () => {
    setIsHovered(true)
  }

  const onMouseLeave = () => {
    setIsHovered(false)
  }

  return (
    <Element
      elementName="tr"
      onClick={() => onRowClick(rowId)}
      onContextMenu={(e) => onRightClick(e, rowId)}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      style={{ backgroundColor: isHovered ? '#ccc' : 'transparent' }}
    >
      {schema.map(({ colId, render, tdStyle, renderCustom }, colIndex) => {
        return (
          <Cell
            key={colId}
            colId={colId}
            getDataFromRedux={getDataFromRedux}
            rowId={rowId}
            rowIndex={rowIndex}
            render={render}
            renderCustom={renderCustom}
            tdStyle={tdStyle}
            sticky={isStickyFirstCol && colIndex === 0}
            isHovered={isHovered}
            isSelected={isSelected}
          />
        )
      })}
    </Element>
  )
}

Row.propTypes = {
  getDataFromRedux: PropTypes.func.isRequired,
  rowId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  rowIndex: PropTypes.number.isRequired,
  schema: PropTypes.array.isRequired,
  isStickyFirstCol: PropTypes.bool,
  onRowClick: PropTypes.func,
  selectedRowId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.object,
  ]),
}

Row.defaultProps = {
  isStickyFirstCol: false,
  onRowClick: () => {},
}
